<button
  mat-button
  [type]="type"
  class="mt-btn {{ activeClass }}"
  [ngClass]="class"
  [color]="color"
  [disabled]="disabled || loading"
  (click)="action()"
  >
  <ng-content></ng-content>
  @if (loading) {
    <span class="ic_refresh rotate ml-5"></span>
  }
</button>
